import API from '../index';
import { Order, CollectMethod, PickupTime } from '../../types/common';
import Formatter from '../../utils/formatter';

interface Request {
  orderId: string;
  method: CollectMethod;
  time?: PickupTime;
}

const updatePickup = async ({ orderId, method, time }: Request): Promise<Order> => {
  const selfPickup = method === CollectMethod.DROPOFF;

  let pickupTime;

  if (selfPickup) {
    // API requires fields but not using it, dummy data here.
    pickupTime = {
      date: Formatter.date(new Date(), `yyyy-MM-dd`),
      from: Formatter.date(new Date(), `HH:mm`),
      to: Formatter.date(new Date(), `HH:mm`),
    };
  } else {
    pickupTime = time;
  }

  const data: Order = await API.post(`/orders/${orderId}/pickup`, {
    selfPickup,
    ...pickupTime,
  });

  return data;
};

export default updatePickup;
